import {
  AI_CONVERSATION_REQUEST,
  AI_CONVERSATION_FAILURE,
  FETCH_AI_CONVERSATIONS_SUCCESS,
  GET_AI_CONVERSATION_SUCCESS,
  SEND_AI_MESSAGE_REQUEST,
  SEND_AI_MESSAGE_SUCCESS,
  SEND_AI_MESSAGE_FAILURE,
  FETCH_AI_USAGE_STATS_SUCCESS,
  FETCH_AI_USAGE_STATS_CHARTS_SUCCESS,
} from "../action/types";

const initialState = {
  conversations: [],
  currentConversation: null,
  total: 0,
  loading: false,
  error: null,
  isSending: false,
  usageStats: null,
  chartsTopKeywords: [],
};

const aiConversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_CONVERSATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AI_CONVERSATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_AI_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        conversations: action.payload.data || [],
        total: action.payload.total || 0,
      };
    case GET_AI_CONVERSATION_SUCCESS:
      return {
        ...state,
        loading: false,
        currentConversation: action.payload,
      };
    case FETCH_AI_USAGE_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        usageStats: action.payload,
      };
    case FETCH_AI_USAGE_STATS_CHARTS_SUCCESS:
      return {
        ...state,
        chartsTopKeywords: action.payload || [],
      };
    case SEND_AI_MESSAGE_REQUEST:
      return {
        ...state,
        isSending: true,
      };
    case SEND_AI_MESSAGE_SUCCESS:
      return {
        ...state,
        isSending: false,
      };
    case SEND_AI_MESSAGE_FAILURE:
      return {
        ...state,
        isSending: false,
      };
    default:
      return state;
  }
};

export default aiConversationsReducer;
